<router-outlet></router-outlet>

<swal #reserveSuccess title="Se ha enviado correctamente!" text="En breve nos pondremos en contacto, muchas gracias!" type="success">
</swal>
<swal #reserveError title="Se ha enviado correctamente!" text="En breve nos pondremos en contacto, muchas gracias!" type="error">
</swal>